export default __webpack_public_path__ + "static/media/nuove-indicazioni.d61d876a.png";